<ng-container *ngIf="jurisdiction$ | async as jurisdiction">
	<obg-dga-regulatory-items-container [inGame]="inGame" *ngIf="jurisdiction === dgaJurisdiction">
	</obg-dga-regulatory-items-container>

	<obg-standard-regulatory-items-component [inGame]="inGame" *ngIf="standardJurisdictions.includes(jurisdiction)">
	</obg-standard-regulatory-items-component>
</ng-container>
